import React, { useContext, useEffect, useState } from 'react'
import About_Banner from './about-banner/About_Banner'
import Welcome_Section from './welcome-section/Welcome_Section'
import Why_Choose from './why-choose/Why_Choose'
import Our_Achievements from '../home/our-achievements/Our_Achievements'
import Why_Choose_Us from '../home/why-choose-us/Why_Choose_Us'
import Blogs_Section from '../home/blogs-section/Blogs_Section'
import { Context } from '../../utils/context'
import { AboutusAbout } from '../../utils/apis/AboutUs/AboutUs'

const About_Us = () => {

    const {
        IMG_URL,
    } = useContext(Context);

    const [abountUs, setAbountUs] = useState();
    const getAllAbountUs = async () => {
        const res = await AboutusAbout();

        if (res?.success) {
            setAbountUs(res?.data);
        } else {
            console.error('Error fetching  data:', res?.error);
        }
    }

    useEffect(() => {
        getAllAbountUs();
    }, []);
    return (
        <>
            <About_Banner banner={IMG_URL + abountUs?.image} />
            <Welcome_Section abountUs={abountUs} IMG_URL={IMG_URL} />
            <Why_Choose />
            <Our_Achievements />
            <Why_Choose_Us />
            <Blogs_Section />
        </>
    )
}

export default About_Us